/**
 * Recent destination searches, persisted in localStorage. Powers the "Recent
 * searches" section of the destination autocomplete. Plain strings (the typed /
 * picked destination), most-recent first, de-duplicated case-insensitively.
 */

const KEY = 'kasa_recent_destinations'
const MAX = 6

export function getRecentSearches(): string[] {
  try {
    const raw = localStorage.getItem(KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function addRecentSearch(term: string): void {
  const t = term.trim()
  if (!t) return
  const next = [t, ...getRecentSearches().filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, MAX)
  try {
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    /* storage full / disabled — non-fatal */
  }
}
